import { IApplicationState } from '../../types/redux';

export function getIsUpcomingSale(state: IApplicationState): boolean {
  return state.newbuilding.isUpcomingSale || false;
}
